import { Injectable } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppConfigService } from './app-config.service';
import { ErrorHandlerService } from './error-handler.service';

@Injectable({
  providedIn: 'root'
})
export class EulaService {

  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private appConfigService: AppConfigService,
    private errorHandler: ErrorHandlerService) { }

  getEula(): Observable<SafeHtml> {
    const headers = new HttpHeaders().set('Content-Type', 'text/html');
    return this.http.get('/assets/LexbeAgreement.html', { headers, responseType: 'text' })
      .pipe(
        catchError(this.errorHandler.handleError<any>(`Failed to retrieve eula agreement html`)),
        map((responseHtml: string) => this.sanitizer.bypassSecurityTrustHtml(responseHtml))
      );
  }

  signEula(): Observable<any> {
    const url = `${this.appConfigService.getConfig().webApi}/api2/eula`;
    return this.http.post(url, {})
      .pipe(catchError(this.errorHandler.handleError<any>(`signEula failed in EulaService`)));
  }
}
